<template>
	<svg :width="props.width" :height="props.height" viewBox="0 0 35 34" fill="none" xmlns="http://www.w3.org/2000/svg">
		<g clip-path="url(#clip0_21737_14130)">
			<path
				d="M16.5763 5.46963C16.7883 4.99721 17.4591 4.99721 17.6711 5.46963L20.9132 12.6932C21.0004 12.8876 21.1842 13.0211 21.396 13.044L29.2679 13.8952C29.7827 13.9509 29.99 14.5888 29.6062 14.9364L23.7381 20.252C23.5801 20.3951 23.5099 20.6111 23.5536 20.8197L25.1766 28.5693C25.2828 29.0761 24.7401 29.4704 24.2909 29.2128L17.4221 25.2745C17.2373 25.1685 17.0101 25.1685 16.8253 25.2745L9.95647 29.2128C9.50725 29.4704 8.96462 29.0761 9.07077 28.5693L10.6938 20.8197C10.7375 20.6111 10.6673 20.3951 10.5093 20.252L4.64118 14.9364C4.2574 14.5888 4.46467 13.9509 4.97949 13.8952L12.8513 13.044C13.0632 13.0211 13.247 12.8876 13.3342 12.6932L16.5763 5.46963Z"
				:fill="props.iconColor"
			/>
		</g>
		<defs>
			<clipPath id="clip0_21737_14130">
				<rect width="34" height="34" :fill="props.iconColor" transform="translate(0.125)" />
			</clipPath>
		</defs>
	</svg>
</template>

<script setup lang="ts">
const props = withDefaults(
	defineProps<{
		width?: string | number;
		height?: string | number;
		iconColor?: string;
	}>(),
	{
		width: 34,
		height: 34,
		iconColor: '#ffff',
	}
);
</script>

<style lang="scss" scoped></style>
